import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
          <img
            src="https://public.readdy.ai/ai/img_res/ffeb34b9-9575-4094-bf02-832cfc639083.png"
            alt="SERGAS S.R.L. Logo"
            className="h-12 w-auto"
          />
          <span className={`text-2xl font-bold transition-colors ${isScrolled ? 'text-[#1A2B4A]' : 'text-white'}`}>
            SERGAS S.R.L.
          </span>
        </div>
        <div className="flex items-center gap-10">
          <button
            onClick={() => scrollToSection('home')}
            className={`text-sm font-medium uppercase tracking-wide transition-colors hover:text-[#00A8E8] ${
              isScrolled ? 'text-[#4A4A4A]' : 'text-white'
            }`}
          >
            Home
          </button>
          <button
            onClick={() => scrollToSection('vpn-service')}
            className={`text-sm font-medium uppercase tracking-wide transition-colors hover:text-[#00A8E8] ${
              isScrolled ? 'text-[#4A4A4A]' : 'text-white'
            }`}
          >
            VPN Service
          </button>
          <button
            onClick={() => scrollToSection('features')}
            className={`text-sm font-medium uppercase tracking-wide transition-colors hover:text-[#00A8E8] ${
              isScrolled ? 'text-[#4A4A4A]' : 'text-white'
            }`}
          >
            Features
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-medium uppercase tracking-wide transition-colors hover:text-[#00A8E8] ${
              isScrolled ? 'text-[#4A4A4A]' : 'text-white'
            }`}
          >
            Contact
          </button>
          <button
            onClick={() => scrollToSection('privacy')}
            className={`text-sm font-medium uppercase tracking-wide transition-colors hover:text-[#00A8E8] ${
              isScrolled ? 'text-[#4A4A4A]' : 'text-white'
            }`}
          >
            Privacy
          </button>
        </div>
      </div>
    </nav>
  );
}
